<panel *ngIf="!loading">
  <select header [(ngModel)]="mode">
    <option value="groups">{{"Danh sách nhóm dịch vụ" | lang}}</option>
    <option value="services">{{"Danh sách dịch vụ" | lang}}</option>
  </select>

  <div class="flex" right *ngIf="mode == 'services'">
    <text-filter [target]="services" [placeholder]="'Tìm dịch vụ'"></text-filter>
    <button class="text-white bg-primary std-margin-left" (click)="editService(null)"><i class="fa fa-plus"></i></button>
  </div>

  <table class="data hover" responsive *ngIf="mode == 'services'">
    <tr>
      <th>{{"Mã chuyển khoản" | lang}}</th>
      <th>{{"Tên" | lang}}</th>
      <th class="text-center">{{"Nhóm" | lang}}</th>
      <th>{{"Địa chỉ" | lang}}</th>
    </tr>
    <tr *ngFor="let i of services.matches" (click)="editService(i)">
      <td class="spacy text-primary">S{{i.ID}}</td>
      <td class="bold">{{i.Name}}</td>
      <td class="capitalize text-info">{{group(i)}}</td>
      <td>{{i.Address}}</td>
    </tr>
  </table>

  <div class="flex" right *ngIf="mode == 'groups'">
    <text-filter [target]="groups" [placeholder]="'Tìm nhóm'"></text-filter>
    <button class="text-white bg-primary std-margin-left" (click)="editGroup(null)"><i class="fa fa-plus"></i></button>
  </div>

  <table class="data hover" responsive *ngIf="mode == 'groups'">
    <tr>
      <th class="text-left">{{"Tên" | lang}}</th>
      <th class="text-left">{{"Chú thích" | lang}}</th>
    </tr>
    <tr *ngFor="let i of groups.matches" (click)="editGroup(i)">
      <td class="bold capitalize">{{i.Name}}</td>
      <td>{{i.Description}}</td>
    </tr>
  </table>
</panel>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
